<template>
  <div class="report-bd tb" style="padding: 0">
    <custom-tab v-model="logState" :list="tabList"></custom-tab>
    <device-log v-if="logState === 1"></device-log>
    <location-log v-if="logState === 2"></location-log>
    <department-log v-if="logState === 3"></department-log>
  </div>
</template>
<script>
import deviceLog from './children/device_log.vue';
import locationLog from './children/location_log.vue';
import departmentLog from './children/department_log.vue';

export default {
  name: 'factoryStock',
  mixins: [],
  components: { deviceLog, locationLog, departmentLog },
  data() {
    return {
      provide: true,
      logState: 1,
      totalRows: 0,
      tabList: [],
    };
  },

  mounted: function () {
    this.getFuncView(null, () => {
      const tab = [];
      if (this.funcView.runLog_device_list) {
        tab.push({ name: this.$t('report_runLog.ji_qi'), value: 1 });
      }
      if (this.funcView.runLog_location_list) {
        tab.push({ name: this.$t('report_runLog.xiang_mu'), value: 2 });
      }
      if (this.funcView.runLog_department_list) {
        tab.push({ name: this.$t('report_runLog.pian_qu_bu_men'), value: 3 });
      }
      this.tabList = tab;
      this.logState = this.tabList[0].value;
    });
  },
  methods: {},
};
</script>

<style lang="scss">
// @import '@/style/colors.scss';
.report-bd {
  .week-picker,
  .season-picker,
  .year-picker {
    display: flex;
    justify-content: space-between;
    .el-input {
      width: 47% !important;
      &:last-of-type {
        float: right;
      }
    }
    // .icon-calendar:before{
    //   content: "\E78E";
    // }
    // i {
    //   flex: 1;
    //   text-align: center;
    // }
  }
  .select-date {
    .el-input .el-input__inner {
      cursor: pointer;
      text-align: center;
    }
  }

  .season-picker {
    display: flex;
    justify-content: space-between;
    .quarter-picker {
      width: 47% !important;
      .el-input {
        width: 100% !important;
      }
      &:last-of-type {
        float: right;
      }
    }
    // i {
    //   flex: 1;
    //   text-align: center;
    // }
  }

  // 时间框
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    .el-input__inner {
      padding: 0 12px 0 32px;
      font-size: 14px;
    }
    .el-input__prefix {
      left: 10px;
    }
    .icon-calendar {
      font-size: 14px;
      color: rgba(13, 154, 224, 1);
    }
  }
}
</style>
